import React from "react";
import { Link } from "react-router-dom";
import { Leaf, MapPin, Users, Award, ArrowRight } from "lucide-react";
import Seo from "./Seo";

const IMG = "https://images.unsplash.com/photo-1605600659908-0ef719419d41?w=1600&q=80&auto=format&fit=crop";

export default function APropos() {
  return (
    <div>
      <Seo
        title="À propos — FB Environnement, centre de recyclage agréé"
        description="FB Environnement est un centre de recyclage à taille humaine basé à Saint-Victoret, au service des professionnels des Bouches-du-Rhône. Tri, valorisation et traçabilité garantis."
        path="/a-propos"
      />
      <section className="bg-gradient-to-br from-[#0f3a18] to-[#1F6B2E] text-white">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-16 sm:py-20">
          <span className="inline-block bg-[#9DCB2E] text-[#0f3a18] font-black uppercase tracking-[0.15em] text-xs px-3 py-1.5 rounded-full">
            L&apos;entreprise
          </span>
          <h1 className="font-heading font-black text-4xl sm:text-5xl tracking-tight mt-5 max-w-3xl">
            FB Environnement, votre centre de recyclage local
          </h1>
          <p className="text-stone-100 text-lg mt-4 max-w-2xl">
            Une équipe à taille humaine, implantée à Saint-Victoret, au service des professionnels des Bouches-du-Rhône.
          </p>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 grid lg:grid-cols-2 gap-10 items-center">
        <div className="rounded-3xl overflow-hidden shadow-2xl shadow-[#1F6B2E]/15 aspect-[4/3]">
          <img src={IMG} alt="FB Environnement" className="w-full h-full object-cover" />
        </div>
        <div>
          <h2 className="font-heading font-black text-3xl text-stone-900">Notre mission</h2>
          <p className="text-stone-600 mt-3 leading-relaxed">
            Offrir aux professionnels du BTP, de l&apos;industrie et du transport une solution simple,
            économique et tracée pour évacuer leurs déchets. Chez FB Environnement, chaque benne déposée
            est triée, pesée et orientée vers la filière de valorisation adaptée.
          </p>
          <p className="text-stone-600 mt-3 leading-relaxed">
            Nous croyons qu&apos;une bonne gestion des déchets, c&apos;est avant tout de la proximité,
            de la rigueur et de l&apos;écoute. Pas de fausses promesses, pas de prix gonflés —
            une relation transparente avec nos clients.
          </p>
        </div>
      </section>

      <section className="bg-[#f6faf0]">
        <div className="max-w-6xl mx-auto px-4 sm:px-6 py-14">
          <h2 className="font-heading font-black text-3xl text-stone-900 text-center">Nos engagements</h2>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-8">
            {[
              { icon: <Leaf />, t: "Environnement", d: "Filières de valorisation conformes à la réglementation." },
              { icon: <Award />, t: "Traçabilité", d: "Bons de pesée et bordereaux à chaque dépôt." },
              { icon: <Users />, t: "Proximité", d: "Une équipe locale, accueillante, à votre écoute." },
              { icon: <MapPin />, t: "Local", d: "100 % implantation Saint-Victoret, zone industrielle." },
            ].map((b) => (
              <div key={b.t} className="bg-white rounded-2xl border border-stone-100 p-5 text-center hover:-translate-y-1 hover:shadow-md transition-all">
                <div className="w-14 h-14 rounded-2xl bg-[#9DCB2E] text-[#0f3a18] grid place-items-center mx-auto mb-3">
                  {React.cloneElement(b.icon, { className: "w-7 h-7", strokeWidth: 2.5 })}
                </div>
                <div className="font-heading font-black">{b.t}</div>
                <div className="text-sm text-stone-600 mt-1">{b.d}</div>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="max-w-6xl mx-auto px-4 sm:px-6 py-14 text-center">
        <h2 className="font-heading font-black text-3xl text-stone-900">Envie d&apos;en savoir plus ?</h2>
        <p className="text-stone-600 mt-3 max-w-xl mx-auto">
          Pour plus d&apos;informations sur nos services, nos tarifs ou notre process, contactez-nous.
        </p>
        <Link
          to="/contact"
          className="mt-6 inline-flex items-center gap-2 bg-[#1F6B2E] hover:bg-[#175522] text-white font-bold px-6 py-3.5 rounded-full transition-all active:scale-95"
        >
          Nous contacter <ArrowRight className="w-4 h-4" strokeWidth={3} />
        </Link>
      </section>
    </div>
  );
}
